import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

// Styles
import { List, Wrapper } from './JamstackNavStyles';

const JamstackNav = () => (
  <Wrapper>
    <List>
      <li><Link to={'/jamstack/'}>Intro</Link></li>
      <li><Link to={'/jamstack/story/'}>Story</Link></li>
      <li><a
        target='_blank' href={'https://docs.google.com/spreadsheets/d/19sHreIExpPwEHgpys5BM2YD-mrx-0cF74hl_VlLjxuM/edit#gid=0'}>Data</a></li>
      <li><Link to={'/jamstack/tools/'}>Tools</Link></li>
      <li><Link to={'/jamstack/architecture/'}>Architecture</Link></li>
      <li><Link to={'/jamstack/pages/'}>Pages</Link></li>
      <li><Link to={'/jamstack/card/'}>Card Component</Link></li>
      <li><Link to={'/jamstack/search/'}>Search Component</Link></li>
      <li><Link to={'/'}>Full Site</Link></li>
    </List>
  </Wrapper>
);

export default JamstackNav;



// WEBPACK FOOTER //
// ./src/components/JamstackNav/JamstackNav.jsx